import React from 'react'
import { useTranslation } from 'react-i18next'

import { notEmpty } from 'helpers/validators'
import ContentBlock from 'components/ContentBlock'
import { Form, Text } from 'components/forms'

const Department = ({ formData, mutations: { updateItem } }) => {
	const [t] = useTranslation()

	return(
		<ContentBlock>
			<Form
				smartSubmit
				initialValues={formData}
				onSubmit={updateItem}
			>
				<Text field='name' label={t('options_section.fields.department_name')} {...notEmpty()}/>
			</Form>
		</ContentBlock>
	)
}

export default Department
